import React from "react"
import {connect} from "react-redux"
import {Link} from "react-router-dom"
import {useTranslation} from "react-i18next"

const icon = require("~/icons/article_32_blue.svg")

const ListItemStock = ({quantity, article, usingLotNumber, destination}) => {
  const lotNumber = article.lot_number
  const {t} = useTranslation()
  return (
    <div className="sh-list-item">
      <img src={icon} alt={"Article"} />
      <div className={"content"}>
        <Link to={`/article/${article.barcode}`}>
          <div className="primary">
            {article.product.name} &mdash; {article.barcode}
          </div>

          <div className="secondary">
            <span>
              {t("destinations.detail.stocks.expiryDate")}:{" "}
              {article.expiry_date || "n/a"};
            </span>

            <span>
              <strong>
                {t("destinations.detail.stocks.stockedOut", {
                  quantity: article.stocked_out_quantity,
                  unit: article.product.unit,
                  destination: destination.name
                })}
              </strong>
            </span>

            {usingLotNumber && lotNumber && (
              <span>
                {t("destinations.detail.stocks.lotNumber")} «
                <strong>{lotNumber}</strong>»
              </span>
            )}
          </div>
        </Link>
      </div>
    </div>
  )
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {usingLotNumber} = settings
  return {usingLotNumber}
}

export default connect(mapStateToProps)(ListItemStock)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemStock.js